<template>
  <div class="gallery-manager">
    <h2>Manage Events</h2>
    <form @submit.prevent="handleSubmit">
      <input type="text" v-model="eventName" placeholder="Event Name" required>
      <textarea v-model="eventAbout" rows="4" cols="38" placeholder="A little bit about the event...">A little bit about the event...</textarea>
      <DropZone @drop.prevent="drop" @change="selectedFile" />
      <button :disabled="toggleModal">Upload</button>
      <span class="file-info">File: {{ dropzoneFile.name }}</span>
      <span v-if="dropzoneFile" class="file-info">Size: {{Math.round((((dropzoneFile.size/1000)+Number.EPSILON)*100)/100)}}Kb</span>
      <!-- <span v-if="uploadProgress" class="file-info-status">{{uploadProgress}}</span>
      <span v-if="uploadError" class="file-info-error">{{uploadError}}</span> -->
      <span v-if="dropzoneFile"><span v-if="dropzoneFile.size >= 5000000" class="file-info-error">File too Large</span></span>
    </form>
    <div
      v-for="event in events"
      :key="event.id"
      class="event-snippet"
    >
      <event-list :event="event" @deletion="changed" />
    </div>
    <teleport to="#modals">
      <modal v-if="toggleModal">Uploading...</modal>
    </teleport>
  </div>
</template>

<script>
import DropZone from './DropZone.vue'
import Modal from '@/components/Modal'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import useUploadEvent from '@/composables/useUploadEvent'
import EventList from './EventList.vue'
export default {
  name: 'ManageGallery',
  props: ['events'],
  components: {
    DropZone,
    Modal,
    EventList
  },
  setup () {
    const dropzoneFile = ref('')
    const eventName = ref('')
    const eventAbout = ref('')
    const toggleModal = ref(false)
    const router = useRouter()
    const { uploadStatus, err, upload } = useUploadEvent()
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    }
    const selectedFile = () => {
      dropzoneFile.value = document.querySelector('.dropzoneFile').files[0]
    }
    const changed = () => {
      router.push({ name: 'Administration' })
    }

    const handleSubmit = async () => {
      toggleModal.value = true
      // Upload the file and metadata
      await upload(eventName.value, eventAbout.value, dropzoneFile.value.name, dropzoneFile.value)
      if (!err.value) {
        setTimeout(() => {
          toggleModal.value = false
          router.push({ name: 'Administration' })
        }, 8000)
      } else {
        console.log(err)
      }
    }
    return { dropzoneFile, drop, selectedFile, eventAbout, eventName, toggleModal, changed, handleSubmit, uploadStatus }
  }
}
</script>

<style>
.gallery-manager {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f1f1f1;
}
.gallery-manager h2 {
  font-size: 1.2em;
  margin-bottom: 10px;
}
.gallery-manager .file-info {
  margin-top: 32px;
}
.gallery-manager input {
  margin-bottom: 12px;
}
</style>
